module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-social-media-slide-3.66e9dd19.jpg";